import { useFlags } from 'launchdarkly-react-client-sdk';

import NewNotePopup from './newNotePopup';
import OldNotePopup from './notePopup';

const NotePopup = () => {
  const { enableBillingUpdates } = useFlags();

  if (enableBillingUpdates) {
    return <NewNotePopup />;
  }
  return <OldNotePopup />;
};

export default NotePopup;
